import React, { Fragment } from "react"

import clearButton from "./ClearButton"
import { JARGON, KEY_VALUES, SCOPE } from "../modules/constants"
import addToMenu from "../components/layout/NexusMenu/addToMenu"
import ResultsMessage from '../components/searchCompanies/ResultsMessage'

import HOOK from "../components/hooks"

//#region material ui
import Box from "@mui/material/Box"
import FormControl from '@mui/material/FormControl'
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import TextField from "@mui/material/TextField"
//#endregion material ui

import Tooltip from '@mui/material/Tooltip'

const leftMargin = 20

const ChSearchForm = props => {
  // console.log('ChSearchForm props:', props)

  const { components, features, filteredSearchResults, handleSearchStringChange, handleSearchStringClear, handleSearchStringSubmit, handleRandom, searchString, submitting, newSearch, tabIndex } = props
  // @ts-ignore
  window.prevPath = "/company-search"

  const companiesButtonDisabled = searchString.length < KEY_VALUES.MIN_SEARCH_STR_LEN || newSearch === SCOPE.COMPANIES || Boolean(submitting)
  const officersButtonDisabled = searchString.length < KEY_VALUES.MIN_SEARCH_STR_LEN || newSearch === SCOPE.OFFICERS || Boolean(submitting)
  const randomButtonDisabled = submitting === SCOPE.RANDOM || Boolean(submitting)

  const searchButton = ({ leftMargin, scope, disabled, buttonLabel, hook, style }) =>
    <Button
      style={{ height: "auto", width: "auto", marginLeft: leftMargin, marginBottom: 20, color: "white", ...style }}
      className="submitButton"
      variant="contained"
      color="primary"
      size="medium"
      onClick={e => handleSearchStringSubmit({ e, scope, hook })}
      disabled={disabled}
    >
      {submitting === "search" ? <CircularProgress size={24} /> : buttonLabel}
    </Button>

  const textFieldAndMessage = () => (
    <React.Fragment>
      <TextField
        style={{ marginTop: 5, marginBottom: -5, backgroundColor: "white" }}
        id="companySearchFormTextField"
        variant="outlined"
        label={`UK company, number, or ${JARGON.OFFICER.toLowerCase()} (min ${KEY_VALUES.MIN_SEARCH_STR_LEN} chars.)`}
        value={searchString}
        fullWidth
        InputProps={clearButton({ searchString, handleSearchStringClear, tabIndex, textInput: null })}
        inputProps={{ spellCheck: "false" }}
        onChange={e => handleSearchStringChange({ e })}
      >
      </TextField>

      {/* if searchResults.kind matches at least one of the properties of KIND.SEARCH */}
      <h4 style={{ marginLeft: -leftMargin, marginBottom: 12, textAlign: "center" }}>
        {ResultsMessage(filteredSearchResults)}
      </h4>

    </React.Fragment>
  )

  const companiesCheckboxes = () =>
    <React.Fragment>
      <FormControl>
        {
          addToMenu({
            ...props,
            disabled: officersButtonDisabled,
            hooks: [HOOK.COMPANY_SEARCH],
            text: {
              clickable: true,
              text: "Company Status:",
              tooltipTitle: "",
            },
          })
        }
        {
          addToMenu({
            ...props,
            disabled: officersButtonDisabled,
            hooks: [HOOK.COMPANY_SEARCH],
          })
        }
      </FormControl>

      <FormControl>
        {
          addToMenu({
            ...props,
            disabled: officersButtonDisabled,
            hooks: [HOOK.COMPANY_REG_TYPE],
            text: {
              clickable: true,
              text: "Company Type:",
              tooltipTitle: "",
            },
          })
        }
        {
          addToMenu({
            ...props,
            disabled: officersButtonDisabled,
            hooks: [HOOK.COMPANY_REG_TYPE],
          })
        }
      </FormControl>
    </React.Fragment>

  const officersCheckboxes = () =>
    <FormControl style={{ paddingLeft: 10 }}>
      {
        addToMenu({
          ...props,
          disabled: companiesButtonDisabled,
          dontColorUnchecked: true,
          hooks: [HOOK.OFFICER_SEARCH],
          text: {
            clickable: true,
            text: "Options",
            tooltipTitle: "",
          },
        })
      }
      {
        addToMenu({
          ...props,
          disabled: companiesButtonDisabled,
          dontColorUnchecked: true,
          hooks: [HOOK.OFFICER_SEARCH],
        })
      }
    </FormControl>

  const companiesButton = () =>
    // @ts-ignore
    <Box>
      {!companiesButtonDisabled &&
        <Tooltip placement="top" title="search only for companies">
          {searchButton({ leftMargin: 0, scope: SCOPE.COMPANIES, disabled: companiesButtonDisabled, buttonLabel: "companies", style: {}, hook: null })}
        </Tooltip>
      }

      {companiesButtonDisabled &&
        searchButton({ leftMargin: 0, scope: SCOPE.COMPANIES, disabled: companiesButtonDisabled, buttonLabel: "companies", style: {}, hook: null })
      }
    </Box>

  const officersButton = () =>
    // @ts-ignore
    <Box style={{ width: "100%" }}>
      {!officersButtonDisabled &&
        <Tooltip placement="top" title={`search only for ${JARGON.OFFICER.toLowerCase()}s (an ${JARGON.OFFICER.toLowerCase()} is a director, company secretary or other person with a legal role in a company)`}>
          {searchButton({ leftMargin: 10, scope: SCOPE.OFFICERS, disabled: officersButtonDisabled, buttonLabel: `${JARGON.OFFICER.toLowerCase()}s`, style: {}, hook: HOOK.OFFICER_SEARCH })}
        </Tooltip>
      }

      {officersButtonDisabled &&
        searchButton({ leftMargin: 10, scope: SCOPE.OFFICERS, disabled: officersButtonDisabled, buttonLabel: `${JARGON.OFFICER}s`, style: {}, hook: HOOK.OFFICER_SEARCH })
      }
    </Box>

  const leftAndRightButtons = () =>
    <
      // @ts-ignore
      Box className="2-columns-container" display="flex">

      {/* LEFT COLUMN */}
      <
        // @ts-ignore
        Box className="left-column" style={{ width: "50%", borderRight: "1px solid lightGrey" }}>
        {companiesButton()}
      </Box>

      {/* RIGHT COLUMN */}
      <
        // @ts-ignore
        Box className="right-column" style={{ width: "50%" }}>
        {officersButton()}
      </Box>
    </Box>

  const textFieldAndButtonsForm = () =>
    <form onSubmit={e => handleSearchStringSubmit({ e, scope: companiesButtonDisabled ? SCOPE.OFFICERS : SCOPE.COMPANIES, hook: null })}>
      <
        // @ts-ignore
        Box className="field" style={{ marginLeft: 18, marginRight: 8 }}>
        {textFieldAndMessage()}
        {leftAndRightButtons()}
      </Box>
    </form>

  const leftAndRightCheckboxes = () =>
    <
      // @ts-ignore
      Box className="field" style={{ marginLeft: 18, marginRight: 8, marginBottom: 10 }}>
      <
        // @ts-ignore
        Box className="2-columns-container" display="flex">

        {/* LEFT COLUMN */}
        <
          // @ts-ignore
          Box className="left-column" style={{ width: "50%", borderRight: "1px solid lightGrey" }}>
          {companiesCheckboxes()}

          {/* RANDOM BUTTON */}
          {features.Developer && randomButton()}
        </Box>

        {/* RIGHT COLUMN */}
        <
          // @ts-ignore
          Box className="right-column" style={{ width: "50%" }}>
          {officersCheckboxes()}
        </Box>
      </Box>
    </Box>

  const randomButton = () =>
    <Fragment>
      {!randomButtonDisabled && <Tooltip placement="top" title="find 5 random companies">
        <Button
          className="submitButton"
          color="primary"
          size="medium"
          onClick={handleRandom}
          disabled={Boolean(submitting)}
        >
          {submitting === SCOPE.RANDOM ? <CircularProgress size={24} /> : SCOPE.RANDOM}
        </Button>
      </Tooltip>
      }

      {randomButtonDisabled &&
        <Button
          className="submitButton"
          color="primary"
          size="medium"
          onClick={handleRandom}
          disabled={Boolean(submitting)}
        >
          {submitting === SCOPE.RANDOM ? <CircularProgress size={24} /> : SCOPE.RANDOM}
        </Button>
      }
    </Fragment>

  return (
    <React.Fragment>
      {!!(components & 1) && textFieldAndButtonsForm()}
      {!!(components & 2) && leftAndRightCheckboxes()}
    </React.Fragment>
  )
}

export default ChSearchForm